import { startRinging } from './ringtone.js';

let stopActive: (() => void) | null = null;

/**
 * Makes an incoming call noticeable: ring tone, blinking tab title and, while the browser
 * is in the background, a desktop notification. One alert at a time; returns its stop.
 */
export function startRingAlert(title: string, body: string): () => void {
  stopActive?.();
  const stopTone = startRinging();
  const savedTitle = document.title;
  let flip = false;
  const timer = setInterval(() => {
    flip = !flip;
    document.title = flip ? title : savedTitle;
  }, 1000);
  let notification: Notification | null = null;
  if (
    document.hidden &&
    typeof Notification !== 'undefined' &&
    Notification.permission === 'granted'
  ) {
    try {
      notification = new Notification(title, {
        body,
        tag: 'indusketch-call',
        requireInteraction: true,
      });
      notification.onclick = () => {
        window.focus();
        notification?.close();
      };
    } catch {
      // Some browsers only allow notifications from a service worker.
    }
  }
  const stop = () => {
    stopTone();
    clearInterval(timer);
    document.title = savedTitle;
    notification?.close();
    if (stopActive === stop) stopActive = null;
  };
  stopActive = stop;
  return stop;
}

/** Asks once (on a click) whether calls may show a notification while the browser is away. */
export function requestCallNotifications(): void {
  if (typeof Notification === 'undefined' || Notification.permission !== 'default') return;
  void Notification.requestPermission().catch(() => undefined);
}
